const zh_tw = require("./apexLocales/zh-tw.json")
export default class CONST {
  static sumGenderOption = {
    chart: {
      defaultLocale: 'zh-tw',
      // width: 380,
      type: 'donut',
      toolbar: {
        show: true, // show/hide download button on apexcharts
        
        export: {
          svg: { filename: undefined },
          png: { filename: undefined },
          csv: { filename: undefined },
        },
      },
      zoom: {
        enabled: false, // show/hide zoom button on apexcharts
      },
      locales: [zh_tw],
    },
    labels: ['男性', '女性'],
    // responsive: [{
    //   breakpoint: 480,
    //   options: {
    //     chart: {
    //       width: 200
    //     },
    //     legend: {
    //       position: 'bottom'
    //     }
    //   }
    // }],
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            total: {
              showAlways: true,
              show: true,
              label: '總數',
              color: '#000000',
              formatter: function (w) {
                return w.globals.seriesTotals.reduce((a, b) => {
                  return a + b
                }, 0)
              }
            },
          value:{
            show: true,
            formatter: function (val) {
              return val
            }
          }
          }
        }
      }
    },
    dataLabels:{
      enabled: true,
      formatter:function (val) {
        // return val.toFixed(1) + "%"
          return Math.round(val) + "%";
     
      },
    },
    tooltip:{
      y: {
        formatter: function (val) {
          return val +" 人";
        }
      },
    },
    
  }

  static sumGenderZeroOption = {
    chart: {
      defaultLocale: 'zh-tw',
      // width: 380,
      type: 'donut',
      toolbar: {
        show: true, // show/hide download button on apexcharts
        
        export: {
          svg: { filename: undefined },
          png: { filename: undefined },
          csv: { filename: undefined },
        },
      },
      zoom: {
        enabled: false, // show/hide zoom button on apexcharts
      },
      locales: [zh_tw],
    },
    labels: ['男性', '女性'],
    responsive: [{
      breakpoint: 480,
      options: {
        // chart: {
        //   width: 200
        // },
        legend: {
          position: 'bottom'
        }
      }
    }],
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            total: {
              showAlways: true,
              show: true,
              label: '總數',
              color: '#000000',
            },
          value:{
            show: true,
            formatter:undefined
          }
          }
        }
      }
    },
    dataLabels:{
      formatter:undefined,
    },
    tooltip:{
      y: {
        formatter: undefined
      },
    },
    
  }

  static sumAgeZeroDonutOption = {
    chart: {
      defaultLocale: 'zh-tw',
      // width: 380,
      type: 'donut',
      toolbar: {
        show: true, // show/hide download button on apexcharts
        
        export: {
          svg: { filename: undefined },
          png: { filename: undefined },
          csv: { filename: undefined },
        },
      },
      zoom: {
        enabled: false, // show/hide zoom button on apexcharts
      },
      locales: [zh_tw],
    },
    labels: ['孩童:0-15歲', '青壯年:16-59歲', '銀髮族:60歲以上'],
    responsive: [{
      breakpoint: 480,
      options: {
        // chart: {
        //   width: 200
        // },
        legend: {
          position: 'bottom'
        }
      }
    }],
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            total: {
              showAlways: true,
              show: true,
              label: '總數',
              color: '#000000'
            },
            value:{
              show: true,
              formatter:undefined
            }
          }
        }
      }
    },
    dataLabels:{
      formatter:undefined,
    },
    legend:{
      position: 'bottom'
    },
    tooltip:{
      y: {
        formatter: undefined
      },
    },
    
  }

  static sumAgeDonutOption = {
    chart: {
      defaultLocale: 'zh-tw',
      // width: 380,
      type: 'donut',
      toolbar: {
        show: true, // show/hide download button on apexcharts
        
        export: {
          svg: { filename: undefined },
          png: { filename: undefined },
          csv: { filename: undefined },
        },
      },
      zoom: {
        enabled: false, // show/hide zoom button on apexcharts
      },
      locales: [zh_tw],
    },
    labels: ['孩童:0-15歲', '青壯年:16-59歲', '銀髮族:60歲以上'],
    responsive: [{
      breakpoint: 480,
      options: {
        // chart: {
        //   width: 200
        // },
        legend: {
          position: 'bottom'
        }
      }
    }],
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            total: {
              showAlways: true,
              show: true,
              label: '總數',
              color: '#000000',
              formatter: function (w) {
                return w.globals.seriesTotals.reduce((a, b) => {
                  return a + b
                }, 0)
              }
            },
            value:{
              show: true,
              formatter: function (val) {
                return val
              }
            }
          }
        }
      }
    },
    dataLabels:{
      enabled: true,
      formatter:function (val) {
        // return val.toFixed(1) + "%";
          return Math.round(val) + "%";
      },
    },
    legend:{
      position: 'bottom'
    },
    tooltip:{
      y: {
        formatter: function (val) {
          return val +" 人";
        }
      },
    },
    
  }

  static sumAgeOption = {
    chart: {
      defaultLocale: 'zh-tw',
      height: 300,
      type: "line",
      toolbar: {
        show: true, // show/hide download button on apexcharts
        export: {
          svg: { filename: undefined },
          png: { filename: undefined },
          csv: { filename: undefined },
        },
      },
      zoom: {
        enabled: false,
      },
      locales: [zh_tw],
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: 2,
      curve: "straight",
      dashArray: 0,
    },
    title: {
      text: "人數",
      align: "left",
    },
    legend: {
      tooltipHoverFormatter: function (val, opts) {
        return (
          val +
          " - " +
          opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] +
          ""
        );
      },
    },
    markers: {
      size: 0,
      hover: {
        sizeOffset: 6,
      },
    },
    xaxis: {
      categories: [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
      ],
    },
    tooltip: {
      y: [
        {
          title: {
            formatter: function (val) {
              return val + "(位)";
            },
          },
        },
        {
          title: {
            formatter: function (val) {
              return val + "(位)";
            },
          },
        },
        {
          title: {
            formatter: function (val) {
              return val + "(位)";
            },
          },
        },
      ],
    },
    grid: {
      borderColor: "#f1f1f1",
    },
  }
}